import { cn } from '~/chords/lib/cn';
import { variants } from '~/chords/lib/variants';

export const chevron = variants({
  base: cn('transform duration-300'),
  variants: {
    state: {
      default: cn('rotate-0'),
      open: cn('rotate-180'),
    },
  },
});
